// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global bokhandlargrand google handorgel */

(function($) {
    const wntrTheme = {
        body: $("body"),
        html: $("html"),
        document: $(document),
        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $("html").removeClass("no-js");

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith("__") && typeof wntrTheme[prop] === "function") {
                    wntrTheme[prop].call();
                }
            }
        },

        /**
         * Init tablesort
         */
        __tableSortInit: () => {
            $(".apartments__wrapper").children(".table").tablesorter();
        },

        /**
         * Google Maps
        */
        __initGoogleMaps: () => {
            const map = wntrTheme.body.find('#map');

            if(map.length) {

                const latitude = parseFloat(map.data('latitude'));
                const longitude = parseFloat(map.data('longitude'));
                const mapsURL = map.data('mapslink');

                let icon = undefined;
                let zoom = 16;

                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    zoom = 15;
                    icon = {
                        url: bokhandlargrand.directory_url + '/src/images/BHG-pin.svg',
                        size: new google.maps.Size(25, 25), scaledSize: new google.maps.Size(25, 25)
                    };
                } else {
                    icon = {
                        url: bokhandlargrand.directory_url + '/src/images/BHG-pin.svg',
                        size: new google.maps.Size(35, 35), scaledSize: new google.maps.Size(35, 35)
                    };
                }

                const mapObject = new google.maps.Map(document.getElementById('map'), {
                    zoom: zoom,
                    disableDefaultUI: true,
                    center: new google.maps.LatLng(latitude, longitude),
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    gestureHandling: 'cooperative',
                    styles: [
                        {
                            "featureType": "administrative",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "lightness": 33
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative",
                            "elementType": "labels.text",
                            "stylers": [
                                {
                                    "gamma": "0.75"
                                }
                            ]
                        },
                        {
                            "featureType": "administrative.neighborhood",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "lightness": "-37"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#f9f9f9"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape.man_made",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "lightness": "40"
                                },
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape.natural",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "lightness": "-37"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape.natural",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "lightness": "100"
                                },
                                {
                                    "weight": "2"
                                }
                            ]
                        },
                        {
                            "featureType": "landscape.natural",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "lightness": "80"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "lightness": "0"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.attraction",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "lightness": "-4"
                                },
                                {
                                    "saturation": "-100"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#c5dac6"
                                },
                                {
                                    "visibility": "on"
                                },
                                {
                                    "saturation": "-95"
                                },
                                {
                                    "lightness": "62"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.business",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.park",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "lightness": 20
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "gamma": "1.00"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels.text",
                            "stylers": [
                                {
                                    "gamma": "0.50"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "gamma": "0.50"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#c5c6c6"
                                },
                                {
                                    "saturation": "-100"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "lightness": "-13"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "lightness": "0"
                                },
                                {
                                    "gamma": "1.09"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#e4d7c6"
                                },
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "lightness": "47"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "lightness": "-12"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "labels.icon",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "color": "#fbfaf7"
                                },
                                {
                                    "lightness": "77"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "lightness": "-5"
                                },
                                {
                                    "saturation": "-100"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "saturation": "-100"
                                },
                                {
                                    "lightness": "-15"
                                }
                            ]
                        },
                        {
                            "featureType": "transit.station.airport",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "lightness": "47"
                                },
                                {
                                    "saturation": "-100"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#acbcc9"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "saturation": "53"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels.text.fill",
                            "stylers": [
                                {
                                    "lightness": "-42"
                                },
                                {
                                    "saturation": "17"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "labels.text.stroke",
                            "stylers": [
                                {
                                    "lightness": "61"
                                }
                            ]
                        }
                    ]
                });

                const infowindow = new google.maps.InfoWindow({
                    content: '<div class="marker"><h2 class="marker__title heading-3"><span class="marker__logo"></span></h2><a href="' + mapsURL + '"target="_blank" rel="noopener norefferer" class="marker__link">Hitta hit</a></div>'
                });

                const marker = new google.maps.Marker({
                    position: new google.maps.LatLng(latitude, longitude),
                    animation: google.maps.Animation.DROP,
                    icon: icon,
                    map: mapObject
                });

                marker.addListener('click', function() {
                    infowindow.open(map, marker);
                });


            }
        },

        /**
         * Init gallery toggle
         */
        __initGalleryToggle: function() {
            const toggleGallery = wntrTheme.body.find('.image-gallery__toggle');
            const toggleImage = wntrTheme.body.find('.image-gallery__image-toggle');
            const images = wntrTheme.body.find('.image-gallery__image');
            const allGallaries = wntrTheme.body.find('.image-gallery__gallery');

            toggleGallery.on('click', function() {
                if(!$(this).hasClass('is-active')) {
                    allGallaries.removeClass('is-active');

                    const currentGalleryID = $(this).data('gallery-id');
                    const currentGallery = wntrTheme.body.find(`.image-gallery__gallery[data-gallery-id='${currentGalleryID}']`);
                    currentGallery.addClass('is-active');

                    images.removeClass('is-active');
                    toggleImage.removeClass('is-active');
                    const firstImage = currentGallery.children().find('.image-gallery__image').first();
                    firstImage.addClass('is-active');
                    const firstToggle = currentGallery.children().find('.image-gallery__image-toggle').first();
                    firstToggle.addClass('is-active');

                    toggleGallery.removeClass('is-active');
                    $(this).addClass('is-active');
                }
            });

            toggleImage.on('click', function() {
                if(!$(this).hasClass('is-active')) {
                    const currentImageId = $(this).data('image-id');
                    const currentGalleryID = $(this).data('gallery-id');
                    $(images).removeClass('is-active');
                    const currentImage = wntrTheme.body.find(`.image-gallery__image[data-image-id='${currentImageId}'][data-gallery-id='${currentGalleryID}']`);
                    $(currentImage).addClass('is-active');
                    toggleImage.removeClass('is-active');
                    $(this).addClass('is-active');
                }
            });
        },

        __onScrollDown: function() {
            if(window.innerWidth <= 1024 && $(window).scrollTop() >= 50) {
                $('header').addClass('started-scroll');
            }
            $(window).scroll(function() {
                if($(this).scrollTop() >= 50 && window.innerWidth <= 1024) {
                    $('header').addClass('started-scroll');
                } else if(window.innerWidth <= 1024) {
                    $('header').removeClass('started-scroll');
                }
            });
        },

        __initializeHandorgel: function() {
            if(wntrTheme.body.find('.handorgel').length > 0) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        __handleChangePageScrollIntoView: function() {
            $(document).ready(function() {
                if(null !== localStorage.getItem("section")) {
                    const section = localStorage.getItem('section');
                    localStorage.clear();
                    wntrTheme.smoothScroll(section);
                }
            });
        },

        __setHeaderStickyOnScroll: function() {
            if(window.innerWidth >= 1024) {
                const bannerHeight = $(".image-banner").outerHeight();
                const heightOfHeader = $(".header.desktop").outerHeight();

                $(window).scroll(function() {
                    if($(window).scrollTop() > (bannerHeight - heightOfHeader)) {
                        $(".header.desktop").addClass('sticky');
                    } else {
                        $(".header.desktop").removeClass('sticky');
                    }
                });
            }
        },

        __tableRowRouting: function() {
            wntrTheme.body.find('.apartments__wrapper tbody tr').on('click', function() {
                window.location = $(this).data("url");
            });
        },

        __fancyboxSettings: function() {
            $('[data-fancybox]').fancybox({
                clickOutside: false,
                touch: false,
                smallBtn: "auto",
                toolbar: "auto",
            });
        },

        __smoothScrollToAnchorPoint: function() {
            wntrTheme.body.find('.header__navigation-inner li a').on("click", function(e) {
                e.preventDefault();

                const classes = $(this).parent().attr("class").split(/\s+/);

                if(!classes.length) {
                    return;
                }

                let section = "";

                classes.forEach((classitem) => {
                    if(classitem.includes('page-section-')) {
                        section = '#' + classitem;
                    } else if(classitem.includes('fancybox')) {
                        $.fancybox.open($('#registration-modal'));
                        return;
                    }
                });

                if(classes.includes('fancybox')) {
                    return;
                }

                // store page-section in localstorage and scroll it into view after page load
                if(!$('body.home').length) {
                    localStorage.setItem('section', section);
                    window.location = '/';
                    return;
                }

                wntrTheme.smoothScroll(section);

            });
        },

        smoothScroll: function(section) {
            if(window.innerWidth <= 1024) {
                $("html, body").animate(
                    {
                        scrollTop: $(section).offset().top - 80,
                    }, 1000
                );
                const header = wntrTheme.body.find('.handorgel__header');
                const content = wntrTheme.body.find('.handorgel__content');
                header.removeClass('handorgel__header--open');
                header.removeClass('handorgel__header--opened');
                content.removeClass('handorgel__content--open');
                content.removeClass('handorgel__content--opened');
            } else {
                $("html, body").animate(
                    {
                        scrollTop: $(section).offset().top - 120,
                    }, 1000
                );
            }
        },

        /**
         * jQuery MatchHeight
         */
        __doMatchHeight: function() {
            wntrTheme.body.find('.card').matchHeight();
        },

        __initSlickSlider: function() {

            const apartmets = wntrTheme.body.find('.associated-apartments__cards');

            if(apartmets.length) {
                const currentName = wntrTheme.body.find('.breadcrumbs__title').data('name');
                const currentCard = wntrTheme.body.find('.card[data-name=' + currentName + ']');
                currentCard.addClass('hover-state');
                currentCard.addClass('no-click');
                currentCard.find('.card__read-more').hide();
                const slickIndex = currentCard.data('slick-index');

                $(apartmets).slick({
                    arrows: true,
                    dots: false,
                    mobileFirst: true,
                    slidesToShow: 2,
                    swipeToSlide: true,
                    infinite: false,
                    initialSlide: slickIndex > 0 ? slickIndex - 1 : slickIndex,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 3,
                            }
                        }
                    ]
                });
            }

            const imageGallery = wntrTheme.body.find('.image-gallery--image-gallery .image-gallery__images');
            if(imageGallery.length) {
                $(imageGallery).slick({
                    arrows: true,
                    dots: false,
                    mobileFirst: true,
                    slidesToShow: 1,
                    swipeToSlide: true,
                    infinite: true,
                    speed: 1500,
                    autoplay: true,
                    autoplaySpeed: 6000,
                });
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);
